module.exports = __webpack_public_path__ + "img/GBP-USD.9404dfb9.png";